export default {
  /* po-mo style translations start */
  "Checking the status of an application": "Қолданбаның күйін тексеру",
  "Here you can check the status of the application": "Мұнда сіз қолданбаның күйін тексере аласыз",
  'Your application is pending': 'Сіздің өтінішіңіз күтілуде',
  'Your application has been approved': 'Сіздің өтінішіңіз мақұлданды',
  'You have been denied a place in a dormitory': 'Сізге жатақханадан орын берілмеді',
  /* po-mo style translations end */

  full_name: 'Толық ат',
  application_reviewing: 'Сіздің өтінішіңіз күтілуде',
  application_approved: 'Сіздің өтінішіңіз мақұлданды',
  application_rejected: 'Сізге жатақханадан орын берілмеді',

  admin: {
    study_place: 'Место обучения',
    payment_method: 'Способ оплаты',
    application_status: 'Статус заявки',
    status: 'Статус заявки',
    settlement_status: 'Статус заселения',
    social_status: 'Социальный статус',
  },

  kafu: {
    title: 'Қазақстан-Американдық еркін университеті',
    description: `Қалалық халықаралық әріптестік жоғары оқу орны /
     мемлекеттік лицензия АБ 0137478 халықаралық аккредиттеу ACBSP (АҚШ) / 
     институционалдық және мамандандырылған аккредиттеу БСҚТА (Қазақстан)`,
    contacts: 'Қабылдау комиссиясының нөмірі',
    address: 'Жатақхана мекенжайы: Шәкәрім даңғылы 160',
    phone: 'Жатақхана телефоны: 50-50-81'
  },

  form: {
    uni_title: 'Қазақстан-Американдық еркін университеті',
    uni_description: `Қалалық халықаралық әріптестік жоғары оқу орны /
     мемлекеттік лицензия АБ 0137478 халықаралық аккредиттеу ACBSP (АҚШ) / 
     институционалдық және мамандандырылған аккредиттеу БСҚТА (Қазақстан)`,
    contacts_title: 'Қабылдау комиссиясының нөмірі',
    address_title: '',
    contacts_col: `
    <p>
      <a href="tel:87232500300">
        <i aria-hidden="true" class="fas fa-phone-alt mr-2"></i>
        8(7232)500-300
      </a>
      <br />
      <a href="tel:87232505030">
        <i aria-hidden="true" class="fas fa-phone-alt mr-2"></i>
        8(7232)50-50-30
      </a>
      <br />
      <a href="tel:77074400001">
        <i aria-hidden="true" class="fas fa-phone-alt mr-2"></i>
        +7-707-440-00-01
      </a>
      <br />
    </p>
    `,
    address_col: `
    <div>Жатақхана мекенжайы: Шәкәрім даңғылы 160</div>
    <div>Жатақхана телефоны: 50-50-81</div>
    `,

    form_title: 'Жатақханаға өтініш формасы',
    select_placeholder: 'Тізімнен таңдаңыз',
    other_placeholder: 'Басқа',
    choose_btn: 'Таңдау',
    search: 'Іздеу',
    closed: 'Өтінімдерді қабылдау жабық',
    reset_btn: 'Тастау',
    load_btn: 'Жүктеу',
    cancel_btn: 'Болдырмау',

    personal_data_title: 'Дербес деректер',
    contact_info_title: 'Байланыс ақпараты',
    additional_info_title: 'Қосымша ақпарат',
    vac_doc: 'Вакцинация төлқұжаты',
    last_name: 'Құжаттар бойынша тегі',
    first_name: 'Аты',
    middle_name: 'Әкесінің аты',
    gender: {
      title: 'Жынысы',
      male: 'Адам',
      female: 'әйел',
    },
    iin: 'ЖСН',
    study_place: 'Оқу орны',
    payment_method: 'Төлем түрі',
    address: 'Тіркелген жері',
    address_tooltip: 'Мынадай толтырыңыз: ел, аймақ, қала, көше, үй, пәтер',
    address_placeholder: 'ел, аймақ, қала, көше, үй, пәтер',

    country: 'Ел',
    region: 'Аймақ',
    city: 'Елді мекеннің атауы (қала, ауыл, т.б.)',
    city_placeholder: 'Нұр-Сұлтан қ.',
    street: 'Көше',
    house: 'Үй',
    flat: 'Пәтер',
    private_house: 'Жеке үй',
    uk_rejection_message: 'Өскемен қаласында тұратын адамдарға жатақхана бөлінбейді',

    email: 'Email',
    phone: 'Байланыс телефоны',
    social_status: {
      label: 'Әлеуметтік жағдайы',
      title: 'Әлеуметтік жағдайды таңда',
    },
    social_status_tooltip: 'Тізімнен күйді таңдап, растайтын құжатты тіркеңіз',
    social_status_doc: 'Әлеуметтік мәртебені растайтын құжат',
    submit_btn: 'Жіберу',
    submitted: 'Сіздің өтінішіңіз жіберілді',

    errors: {
      first_name: 'Атыңызды енгізіңіз!',
      last_name: 'Фамилияңызды енгізіңіз!',
      gender: 'Жынысыңызды көрсетіңіз!',
      iin: 'ЖСН 12 цифрдан тұруы керек!',
      study_place: 'Оқу орнын көрсетіңіз!',
      payment_method: 'Төлем форматын көрсетіңіз!',
      address: 'Тіркеу мекенжайын енгізіңіз!',
      email: 'Электрондық поштаны енгізіңіз!',
      phone: 'Телефон нөміріңізді енгізіңіз!',
      social_status_doc: 'Әлеуметтік мәртебеңізді растайтын құжатты тіркеңіз!',
    },
  },
  article: {
    back_btn: 'Өтініш формасына оралу'
  }
}
